'use strict';

export default class MemAtrTypesCtrl {
  constructor($stateParams, $location, LoaderSvc, MemAtrTypeSvc, GroupAuthSvc) {
    LoaderSvc.start('Loading Member Attributes...');
    var that = this;
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId; // set for group urls
    var groupId = $stateParams.groupId;
    this.groupId = Number(groupId); // convert to number for disable link check

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'memberAttributeType', 'I');

    // default filter
    if(Object.keys($location.search()).length === 0) {
      $location.search({isActive: 'true'}); // string required for url
    }

    that.dataModel = 'mavm';
    MemAtrTypeSvc.query({groupId}).$promise
      .then(function(data) {
        that.data = data;
        that.order = 'displayOrder';
        that.searchField = 'name';
        LoaderSvc.stop();
      })
      .catch(function() {
        LoaderSvc.stopError('Error loading member attributes');
      });
  }
}

MemAtrTypesCtrl.$inject = [
  '$stateParams',
  '$location',
  'LoaderSvc',
  'MemAtrTypeSvc',
  'GroupAuthSvc'
];
